import { InfoBox } from "components";
import { contentStyles } from "../Content";
import RichtextAdapter from "../RichtextAdapter";
import type { InfoBoxAdapterProps } from "./InfoBox.d";

const InfoBoxAdapter = ({ blok: { heading, content } }: InfoBoxAdapterProps) => (
  <InfoBox heading={heading} text={<RichtextAdapter content={content} customStyles={contentStyles} />} />
);

export default InfoBoxAdapter;
